
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutY9vejkzrpZjLFj4WjDK__V0ZQQ4PNd2ClPquViRToTAMeta } from "/opt/source_www_file/www-sanfu-html/app/pages/about.vue?macro=true";
import { default as indexfPYz3yWNgrjpSM4rpLXpGCxsWZ1Yk3Kj_S_5b_jdRaEMeta } from "/opt/source_www_file/www-sanfu-html/app/pages/index.vue?macro=true";
import { default as storesPG6bdwAkid2cNXNeLKoGJthhGeCQjaQiGFyCSEhOHBcMeta } from "/opt/source_www_file/www-sanfu-html/app/pages/stores.vue?macro=true";
import { default as contactmmMZ6rWQzeCdVkiRgxK4ITgwVYQP8B5XBqQAY1refKwMeta } from "/opt/source_www_file/www-sanfu-html/app/pages/contact.vue?macro=true";
import { default as disclaimerSdLrQ3daKZgAbNU10btnK92N_xFE7wEh5O_m6b0HWxcMeta } from "/opt/source_www_file/www-sanfu-html/app/pages/disclaimer.vue?macro=true";
import { default as _91id_93MkqIVzCaxk1V9N8GuCRzePd06OlBfrD_0jWPiJRhKKYMeta } from "/opt/source_www_file/www-sanfu-html/app/pages/activities/[id].vue?macro=true";
import { default as indexE9JI1Pl7vNG8WnOn_3EUgA_Sc_IHG7Cpab2rAE_ANB4Meta } from "/opt/source_www_file/www-sanfu-html/app/pages/activities/index.vue?macro=true";
import { default as component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKcMeta } from "/opt/source_www_file/www-sanfu-html/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKc } from "/opt/source_www_file/www-sanfu-html/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___zh",
    path: "/about",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/about.vue")
  },
  {
    name: "about___id",
    path: "/id/about",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/about.vue")
  },
  {
    name: "index___zh",
    path: "/",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/index.vue")
  },
  {
    name: "stores___zh",
    path: "/stores",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/stores.vue")
  },
  {
    name: "stores___en",
    path: "/en/stores",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/stores.vue")
  },
  {
    name: "stores___id",
    path: "/id/stores",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/stores.vue")
  },
  {
    name: "contact___zh",
    path: "/contact",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/contact.vue")
  },
  {
    name: "contact___id",
    path: "/id/contact",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/contact.vue")
  },
  {
    name: "disclaimer___zh",
    path: "/disclaimer",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/disclaimer.vue")
  },
  {
    name: "disclaimer___en",
    path: "/en/disclaimer",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/disclaimer.vue")
  },
  {
    name: "disclaimer___id",
    path: "/id/disclaimer",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/disclaimer.vue")
  },
  {
    name: "activities-id___zh",
    path: "/activities/:id()",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/activities/[id].vue")
  },
  {
    name: "activities-id___en",
    path: "/en/activities/:id()",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/activities/[id].vue")
  },
  {
    name: "activities-id___id",
    path: "/id/activities/:id()",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/activities/[id].vue")
  },
  {
    name: "activities___zh",
    path: "/activities",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/activities/index.vue")
  },
  {
    name: "activities___en",
    path: "/en/activities",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/activities/index.vue")
  },
  {
    name: "activities___id",
    path: "/id/activities",
    component: () => import("/opt/source_www_file/www-sanfu-html/app/pages/activities/index.vue")
  },
  {
    name: component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKcMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKc
  },
  {
    name: component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKcMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKc
  },
  {
    name: component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKcMeta?.name,
    path: "/id/sitemap.xml",
    component: component_45stubZO0_HcZ4Tpk8h3P9k0HRQh1PtV_HoRYjwqEjUeatjKc
  }
]